"use client";

import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "@/lib/utils";

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => {


  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        "relative flex w-full touch-none items-center select-none",
        className
      )}
      {...props}
    >
      <div className="flex-between absolute top-0 left-0 z-50 h-full w-full max-md:hidden">
        {Array.from({ length: 10 }).map((_, index) => (
          <div
            key={index}
            className={`h-2.5 w-2.5 rounded-[50px] border-[3px] ${props.value?.[0] === (index + 1) * 10 ? "border-transparent" : (props.value?.[0] ?? 0) >= (index + 1) * 10 ? "border-white" : "border-[#565656]"} p-px`}
          />
        ))}
      </div>
      <SliderPrimitive.Track className="relative h-2.5 w-full grow overflow-hidden rounded-full bg-[#0D2435] md:h-[4.5px]">
        <SliderPrimitive.Range className="absolute h-full bg-gradient-to-b from-[#6CB5FF] to-[#1E7BDB]" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb className="block size-6 rounded-full border border-black/10 bg-gradient-to-b from-[#6CB5FF] to-[#1E7BDB] transition-colors disabled:pointer-events-none disabled:opacity-50 md:size-[17.5px]" />
    </SliderPrimitive.Root>
  );
});
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
